import { Down, Shield } from "../icons";
import { Credentials } from "../layout";
import { Covers } from "./covers";

const OUTGOING = [
  ["A. Referring counsellor", "Counsellor name, practice, contact details, ASCHP registration and membership numbers."],
  ["B. Client information", "Client name, date of birth, pronouns, contact details, languages and emergency contact."],
  ["C. Counselling summary", "First and last session dates, total sessions attended, presenting concerns addressed and a brief summary of the work done."],
  ["D. Reason for referral", "Needs exceeding wellness-counselling scope, suspected clinical condition, psychiatric or medical support, specialist trauma therapy, client request, and more."],
  ["E. Risk & safety summary", "Current suicide, self-harm and risk-to-others assessment, plus whether a safety plan is in place."],
  ["F. Receiving practitioner", "Name, profession, organisation, registration number and how the referral was sent."],
  ["G. Client consent declaration", "Client name, date of consent, and both client and counsellor signatures."],
];

export function Outgoing() {
  return (
    <section className="wrap-m section">
      <span className="kicker">Form WC-REF-OUT-01</span>
      <h1 className="center">Outgoing Client Referral</h1>
      <p className="center soft" style={{ maxWidth: 640, margin: "0 auto 2rem" }}>Referring a client <strong>to another professional</strong>. Completed by the referring counsellor and shared only with the receiving practitioner.</p>
      <div className="callout lavender">
        <Shield />
        <div>
          <p><strong>Confidential</strong></p>
          <p>This form contains sensitive client information. A signed client consent form must be obtained before the referral is submitted — without consent it may not be shared with any third party. Retain a copy in the client's confidential file.</p>
        </div>
      </div>
      <p className="center"><a className="btn btn-dark" href="/wwc-outgoing-referral-form.pdf" download><Down /> Download Outgoing Referral Form (PDF)</a></p>
      <h2>What the form covers</h2>
      <Covers items={OUTGOING} />
      <Credentials />
    </section>
  );
}
